
import React, { useState, useEffect } from 'react'
import HEYO from "@heyo.so/js";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
// Pages
import {
  NotFoundPage,
  Home
} from './pages';

// Templates
import { Header } from './pages/templates/Header'
import { Footer } from './pages/templates/Footer'
import { ScrollTop } from 'primereact/scrolltop';

const APIUrl = process.env.REACT_APP_API_URL;
const ProofUrl = process.env.REACT_APP_API_PROOFURL;
const projectIdChat = process.env.REACT_APP_PROJECT_ID;
const mcpheeCredentials = {
  URL: process.env.REACT_APP_MCPHEE_URL,
  KEY: process.env.REACT_APP_MCPHEE_SECRET_KEY
}

HEYO.init({
  projectId: projectIdChat, // optional in production, required on localhost
});

function App() {
  const [account, setAccount] = useState();
  const [transactions, setTransactions] = useState([]);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [headerClass, setheaderClass] = useState();

  const location = useLocation();

  useEffect(() => {

  }, [location]);

  return (
    <div className={location.pathname !== "/" ? ("d-flex flex-column justify-content-start " + headerClass) : headerClass}>

      <Header
        APIUrl={APIUrl}
        setAccount={setAccount}
        ProofUrl={ProofUrl}
        account={account}
        transactions={transactions}
        setTransactions={setTransactions}
        setTransactionLoading={setTransactionLoading}
        navigate={useNavigate()}
      />
      <ScrollTop className="at-the-right scrooll-top" />
      <Routes>
        <Route path="/" element={<Home
          APIUrl={APIUrl} />
        } />

        
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>

      <Footer
        account={account}
        APIUrl={APIUrl}
      />
    </div>
  );
}

export default App;
